import { AppServices } from '@singularsystems/neo-core';
import { AppService, Types as AppTypes } from '../App/Services/AppService';
import { IInvestmentSetupApiClient } from './ApiClients/InvestmentSetupApiClient';
import { IGenericApiClient } from './ApiClients/Catalogues/GenericApiClient';
import { IReportingApiClient as ICatalogueReportingApiClient } from './ApiClients/Catalogues/ReportingApiClient';
import { DomainExportedTypes } from './DomainExportedTypes';
import DataCache from './Services/DataCache';
import { IPipelineApiClient } from './ApiClients/Catalogues/PipelineApiClient';
import { IGeneralApiClient } from './ApiClients/Catalogues/GeneralApiClient';
import { IInvestmentApiClient as ICatalogueInvestmentApiClient } from './ApiClients/Catalogues/InvestmentApiClient';
import { IInvestorApiClient } from './ApiClients/InvestorApiClient';
import { IIssuerApiClient } from './ApiClients/IssuerApiClient';
import { IAuditApiClient } from './ApiClients/AuditApiClient';
import { IIssuerInvestmentApiClient } from './ApiClients/IssuerInvestmentApiClient';
import { IInvestorInvestmentApiClient } from './ApiClients/InvestorInvestmentApiClient';
import { IInvestmentApiClient } from './ApiClients/InvestmentApiClient';
import { IConfigApiClient } from './ApiClients/ConfigApiClient';
import { IImagesApiClient } from './ApiClients/ImagesApiClient';
import IssuerInvestmentCache from './Services/IssuerInvestmentCache';
import { IContactApiClient } from './ApiClients/ContactApiClient';
import { IDividendProcessingApiClient } from './ApiClients/DividendProcessingApiClient';
import { ILetterAuthorisationApiClient } from './ApiClients/LetterAuthorisationApiClient';
import { IPaymentExportApiClient } from './ApiClients/PaymentExportApiClient';
import { ISystemMaintenanceApiClient } from './ApiClients/SystemMaintenanceApiClient';
import { IInvestorInvestmentApprovalApiClient } from './ApiClients/InvestorInvestmentApprovalApiClient';
import { IInternalApproverApiClient } from './ApiClients/InternalApproverApiClient';
import { IUserApiClient } from './ApiClients/UserApiClient';
import { IDocumentsApiClient } from './ApiClients/DocumentsApiClient';
import { IPortalUserApiClient } from './ApiClients/PortalUserApiClient';
import { IInvestorInvestmentNoticeApiClient } from "./ApiClients/InvestorInvestmentNoticeApiClient";
import { ILogApiClient } from "./ApiClients/LogsApiClient";
import { IImportApiClient } from './ApiClients/ImportApiClient';

// Symbols specific to this module.
const DomainTypes = {
    ApiClients: {
        ...DomainExportedTypes.ApiClients,
        Audit: new AppServices.ServiceIdentifier<IAuditApiClient>("ApiClients.Audit"),
        CatalogueInvestment: new AppServices.ServiceIdentifier<ICatalogueInvestmentApiClient>("ApiClients.Catalogue.Investments"),
        CataloguePipeline: new AppServices.ServiceIdentifier<IPipelineApiClient>("ApiClients.Pipeline"),
        CatalogueGeneric: new AppServices.ServiceIdentifier<IGenericApiClient>("ApiClients.Generic"),
        InvestmentSetup: new AppServices.ServiceIdentifier<IInvestmentSetupApiClient>("ApiClients.InvestmentSetup"),
        CatalogueReporting: new AppServices.ServiceIdentifier<ICatalogueReportingApiClient>("ApiClients.Catalogue.Reporting"),
        CatalogueGeneral: new AppServices.ServiceIdentifier<IGeneralApiClient>("ApiClients.General"),
        Investor: new AppServices.ServiceIdentifier<IInvestorApiClient>("ApiClients.InvestorApiClient"),
        Issuer: new AppServices.ServiceIdentifier<IIssuerApiClient>("ApiClients.IssuerApiClient"),
        IssuerInvestment: new AppServices.ServiceIdentifier<IIssuerInvestmentApiClient>("ApiClients.IssuerInvestmentApiClient"),
        InvestorInvestment: new AppServices.ServiceIdentifier<IInvestorInvestmentApiClient>("ApiClients.InvestorInvestmentApiClient"),
        Investment: new AppServices.ServiceIdentifier<IInvestmentApiClient>("ApiClients.InvestmentApiClient"),
        LetterAuthorisation: new AppServices.ServiceIdentifier<ILetterAuthorisationApiClient>("ApiClients.LetterAuthorisationApiClient"),
        Logs: new AppServices.ServiceIdentifier<ILogApiClient>("ApiClients.Logs"),
        Config: new AppServices.ServiceIdentifier<IConfigApiClient>("ApiClients.ConfigApiClient"),
        ImagesApiClient: new AppServices.ServiceIdentifier<IImagesApiClient>("ApiClients.ImagesApiClient"),
        Contact: new AppServices.ServiceIdentifier<IContactApiClient>("ApiClients.ContactApiClient"),
        DividendProcessing: new AppServices.ServiceIdentifier<IDividendProcessingApiClient>("ApiClients.DividendProcessingClient"),
        PaymentExport: new AppServices.ServiceIdentifier<IPaymentExportApiClient>("ApiClients.PaymentExportClient"),
        SystemMaintenance: new AppServices.ServiceIdentifier<ISystemMaintenanceApiClient>("ApiClients.SystemMaintenance"),
        InvestorInvestmentApproval: new AppServices.ServiceIdentifier<IInvestorInvestmentApprovalApiClient>("ApiClients.InvestorInvestmentApproval"),
        InvestorInvestmentNotice: new AppServices.ServiceIdentifier<IInvestorInvestmentNoticeApiClient>("ApiClients.InvestorInvestmentNotice"),
        User: new AppServices.ServiceIdentifier<IUserApiClient>("ApiClients.User"),
        InternalApprover: new AppServices.ServiceIdentifier<IInternalApproverApiClient>("ApiClients.InternalApprover"),
        PortalUser: new AppServices.ServiceIdentifier<IPortalUserApiClient>("ApiClients.PortalUser"),
        Documents: new AppServices.ServiceIdentifier<IDocumentsApiClient>("ApiClients.Documents"),
        Import: new AppServices.ServiceIdentifier<IImportApiClient>("ApiClients.Import"),
    },
    Services: {
        ...DomainExportedTypes.Services,
        DataCache: new AppServices.ServiceIdentifier<DataCache>("Services.DataCache"),
        IssuerInvestmentCache: new AppServices.ServiceIdentifier<IssuerInvestmentCache>("Services.IssuerInvestmentCache")
        
    }
}

// Merged symbols from app for convenience.
const Types = {
    ...AppTypes,
    Domain: DomainTypes
}

export { AppService, Types, DomainTypes }